import { AuthLayoutProps } from "@/types/authLayout";
import { useAuth } from "@/utils/auth-context";
import { useTheme } from "@/utils/theme-context";

import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  const { theme } = useTheme();

  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/course/trial/lessons");
    }
  }, [navigate, isAuthenticated]);

  return (
    <div className="authentication">
      <div className="wrapper">
        <form className={`authentication-box  authentication-box--${theme} `}>
          {children}
        </form>
      </div>
    </div>
  );
};

export default AuthLayout;
